/* DP SHIPPING ELIGIBILITY — detection core.
   One IP→state lookup per visitor (geojs.io, no key), cached 7 days in
   localStorage; a manual state pick overrides IP and lasts 30 days.
   Rules come from window.DPShipRules (snippets/dp-ship-config.liquid).

   FAIL OPEN: if detection fails (ad-blocker, API down, unknown region)
   state stays null, mode() returns 'unknown', productAllowed() returns
   true and no eligibility UI appears anywhere. This layer is a courtesy —
   fulfillment remains the legal backstop.

   API (window.DPShip):
     ready               Promise resolving to the api once state is known
     state               { code, name, source: 'ip'|'manual', ts } | null
     mode()              'open' | 'partial' | 'blocked' | 'unknown'
     productAllowed(t)   t = tag array or comma string → boolean
     setState(code)      manual override; re-announces
   Event: 'dp:ship:ready' on document whenever state is (re)resolved. */
(function () {
  'use strict';
  if (window.DPShip) return;

  var LS_KEY = 'dp_ship_state';
  var TTL_IP = 7 * 864e5;
  var TTL_MANUAL = 30 * 864e5;
  var RULES = window.DPShipRules || {};

  var STATES = {
    alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR',
    california: 'CA', colorado: 'CO', connecticut: 'CT', delaware: 'DE',
    'district of columbia': 'DC', florida: 'FL', georgia: 'GA',
    hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA',
    kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME',
    maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN',
    mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE',
    nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
    'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC',
    'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR',
    pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
    'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT',
    vermont: 'VT', virginia: 'VA', washington: 'WA',
    'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY'
  };
  var NAMES = {};
  for (var n in STATES) {
    NAMES[STATES[n]] = n.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(LS_KEY));
      if (!s || !s.code || !s.ts) return null;
      var ttl = s.source === 'manual' ? TTL_MANUAL : TTL_IP;
      return (Date.now() - s.ts > ttl) ? null : s;
    } catch (e) { return null; }
  }
  function save(s) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }

  function detect() {
    return new Promise(function (resolve) {
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        resolve(null);
      }, 4000);
      fetch('https://get.geojs.io/v1/ip/geo.json', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (geo) {
          clearTimeout(timer);
          if (!geo) return resolve(null);
          if (geo.country_code && geo.country_code !== 'US') {
            // international visitors are handled like a fully blocked state
            return resolve({ code: 'INTL', name: geo.country || 'your country', source: 'ip', ts: Date.now() });
          }
          var code = STATES[String(geo.region || '').toLowerCase()];
          resolve(code ? { code: code, name: NAMES[code], source: 'ip', ts: Date.now() } : null);
        })
        .catch(function () { clearTimeout(timer); resolve(null); });
    });
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('dp:ship:ready', { detail: api }));
  }

  var api = {
    state: null,
    names: NAMES,
    mode: function () {
      var s = api.state;
      if (!s) return 'unknown';
      if (s.code === 'INTL') return 'blocked';
      var rule = RULES[s.code];
      if (!rule) return 'open';
      if (rule.blocked === '*') return 'blocked';
      if (rule.allowed) return 'partial'; // whitelist states (VA, MN)
      return (rule.blocked && rule.blocked.length) ? 'partial' : 'open';
    },
    productAllowed: function (tags) {
      var m = api.mode();
      if (m === 'unknown' || m === 'open') return true;
      var list = (Array.isArray(tags) ? tags : String(tags || '').split(','))
        .map(function (t) { return t.trim().toLowerCase(); });
      // glass and accessories are not hemp products — they ship anywhere,
      // even to fully blocked states
      if (list.indexOf('format:hand pipe') !== -1 || list.indexOf('accessories') !== -1) return true;
      if (m === 'blocked') return false;
      var rule = RULES[api.state.code];
      if (rule.allowed) {
        // whitelist state: only products carrying a compliance tag ship
        for (var a = 0; a < list.length; a++) {
          if (rule.allowed.indexOf(list[a]) !== -1) return true;
        }
        return false;
      }
      for (var i = 0; i < list.length; i++) {
        if (rule.blocked.indexOf(list[i]) !== -1) return false;
      }
      return true;
    },
    setState: function (code) {
      code = String(code || '').toUpperCase();
      if (!NAMES[code]) return;
      api.state = { code: code, name: NAMES[code], source: 'manual', ts: Date.now() };
      save(api.state);
      announce();
    }
  };

  api.ready = Promise.resolve(load())
    .then(function (cached) { return cached || detect(); })
    .then(function (s) {
      api.state = s || null;
      if (s && s.source === 'ip') save(s);
      announce();
      return api;
    });

  window.DPShip = api;

  /* ---- product page eligibility line (under WHAT IT IS) ---- */
  function renderLine() {
    var line = document.querySelector('[data-dp-ship-line]');
    if (!line) return;
    var txt = line.querySelector('[data-dp-ship-text]');
    var s = api.state;
    if (!txt) { line.hidden = true; return; }
    // no state (IP lookup blocked / failed): still say something true rather
    // than leaving the slot empty — the popup lets them pick a state later
    var ok = s ? api.productAllowed(line.getAttribute('data-dp-tags')) : true;
    line.classList.toggle('is-no', !ok);
    // Figma 2558:3698 voice: "SHIPS TO NEW YORK • GET IT BY AUG 13-17";
    // the ETA span/dot only exist on the new product page
    var eta = line.querySelector('[data-dp-ship-eta]');
    var dot = line.querySelector('[data-dp-ship-dot]');
    var showEta = false;
    if (!s) {
      txt.textContent = 'Ships within the US';
      showEta = !!eta;
    } else if (s.code === 'INTL') {
      txt.textContent = 'We currently only ship within the US';
    } else if (ok) {
      txt.textContent = 'Ships to ' + s.name;
      showEta = !!eta;
    } else {
      txt.textContent = 'Not shippable to ' + s.name;
    }
    if (eta && dot) {
      if (showEta) {
        var mn = parseInt(line.getAttribute('data-eta-min'), 10) || 5;
        var mx = parseInt(line.getAttribute('data-eta-max'), 10) || 9;
        var mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var a = new Date(); a.setDate(a.getDate() + mn);
        var b = new Date(); b.setDate(b.getDate() + mx);
        var range = mon[a.getMonth()] + ' ' + a.getDate() + (a.getMonth() === b.getMonth() ? '' : ' - ' + mon[b.getMonth()]) + (a.getMonth() === b.getMonth() ? '-' : ' ') + b.getDate();
        eta.textContent = 'Get it by ' + range;
      }
      eta.hidden = !showEta;
      dot.hidden = !showEta;
    }
    line.hidden = false;
    // forced reflow commits the hidden->visible state, so the fade-up
    // transition plays without depending on rAF (which page transitions
    // can delay past the moment the user is already looking)
    void line.offsetWidth;
    line.classList.add('is-in');
  }

  document.addEventListener('dp:ship:ready', renderLine);
  api.ready.then(renderLine);

  /* ---- shared editorial popup (snippets/dp-ship-popup.liquid) ---- */
  var popup = {
    root: null, outTimer: null, pendingHref: null,
    el: function () {
      if (!popup.root) popup.root = document.getElementById('dp-ship-popup');
      return popup.root;
    },
    open: function (view) {
      var root = popup.el();
      if (!root) return false;
      clearTimeout(popup.outTimer);
      root.querySelectorAll('[data-sp-view]').forEach(function (v) {
        v.hidden = v.getAttribute('data-sp-view') !== view;
      });
      root.hidden = false;
      root.classList.remove('is-out');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      /* keyboard: remember where the reader was, move focus into the
         dialog, and keep Tab inside it while it's up */
      popup.lastFocus = document.activeElement;
      var x = root.querySelector('.dp-sp-x');
      if (x) x.focus({ preventScroll: true });
      if (!popup.keysArmed) {
        popup.keysArmed = true;
        document.addEventListener('keydown', function (e) {
          var r = popup.el();
          if (!r || r.hidden) return;
          if (e.key === 'Escape') { e.preventDefault(); popup.close(); }
          if (e.key === 'Tab') {
            var f = r.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
            f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
            if (!f.length) return;
            var first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && (document.activeElement === last || !r.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
          }
        });
      }
      return true;
    },
    close: function () {
      var root = popup.el();
      if (!root || root.hidden) return;
      root.classList.remove('is-open');
      root.classList.add('is-out');
      popup.pendingHref = null;
      popup.outTimer = setTimeout(function () {
        root.hidden = true;
        root.classList.remove('is-out');
      }, 400);
      if (popup.lastFocus && popup.lastFocus.focus) {
        try { popup.lastFocus.focus({ preventScroll: true }); } catch (e) { /* gone */ }
      }
    }
  };
  api.openPopup = popup.open; // manual re-open hook (design review)

  document.addEventListener('click', function (e) {
    var root = popup.el();
    if (!root || root.hidden) return;
    if (e.target.closest('[data-sp-close]')) popup.close();
    if (e.target.closest('[data-sp-ignore]')) {
      var href = popup.pendingHref;
      if (href) {
        try {
          var ignored = JSON.parse(sessionStorage.getItem('dp_ship_ignored') || '[]');
          if (ignored.indexOf(href) === -1) ignored.push(href);
          sessionStorage.setItem('dp_ship_ignored', JSON.stringify(ignored));
        } catch (err) { /* best-effort */ }
        window.location.href = href;
      } else {
        popup.close();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') popup.close();
  });

  /* ---- once-per-session welcome, after the age gate clears:
     blocked state → contact card; partial state → offer ships-to-you ---- */
  function maybeShowWelcome() {
    var m = api.mode();
    if (m !== 'blocked' && m !== 'partial') return;
    // no welcome on the ships-to-you page itself — they're already there
    if (window.location.pathname.indexOf('/pages/ships-to-you') === 0) return;
    // ?dp_ship=1 replays the popup for design review (same convention as
    // ?dp_age=1 and ?dp_cookie=1)
    var force = new URLSearchParams(window.location.search).has('dp_ship');
    var seen = null;
    try { seen = sessionStorage.getItem('dp_ship_popup_seen'); } catch (e) {}
    if (seen && !force) return;

    var show = function () {
      setTimeout(function () {
        var root = popup.el();
        if (!root) return;
        var s = api.state;
        var view;
        if (m === 'blocked') {
          view = 'blocked';
          var head = root.querySelector('[data-sp-blocked-head]');
          var sub = root.querySelector('[data-sp-blocked-sub]');
          if (s.code === 'INTL') {
            head.textContent = "You're a little far out";
            sub.textContent = 'We currently only ship within the US. If you want to treat a friend stateside — or just say hi — we’re one message away.';
          } else {
            head.textContent = 'We see you, ' + s.name;
            sub.textContent = 'Hemp law in ' + s.name + ' means we can’t ship our THC products your way right now (glass and accessories still travel fine). Want to send something to a friend in a luckier state, or talk it through? We’re around.';
          }
        } else {
          view = 'partial';
          root.querySelector('[data-sp-partial-head]').textContent = 'We see you, ' + s.name;
          root.querySelector('[data-sp-partial-sub]').textContent =
            'A few things can’t follow you home — ' + s.name + ' hemp law says so. Most of the shop still ships your way, and we made you a page with exactly what does.';
        }
        if (popup.open(view)) {
          try {
            sessionStorage.setItem('dp_ship_popup_seen', '1');
            if (m === 'blocked') {
              // no point marketing to someone who can't order — mute the
              // email popup for this session (its own session key)
              sessionStorage.setItem('dp-ep-dismissed', '1');
            }
          } catch (e) { /* best-effort */ }
        }
      }, 3000); /* first of the popup choreography: ship 3s, cookies 10s, email 30s */
    };

    if (document.documentElement.classList.contains('dp-gate')) {
      document.addEventListener('dp:age:passed', show, { once: true });
    } else {
      show();
    }
  }
  api.ready.then(maybeShowWelcome);

  /* ---- partial state: intercept clicks on ineligible product cards.
     Cards stamp their tags on .dp-pcard[data-dp-tags]; links without tag
     data (menus, search, upsell rows) are never intercepted — fail open. */
  document.addEventListener('click', function (e) {
    if (api.mode() !== 'partial') return;
    var a = e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var carrier = a.closest('[data-dp-tags]');
    if (!carrier || api.productAllowed(carrier.getAttribute('data-dp-tags'))) return;
    var href = a.getAttribute('href');
    try {
      var ignored = JSON.parse(sessionStorage.getItem('dp_ship_ignored') || '[]');
      if (ignored.indexOf(href) !== -1) return; // they chose danger already
    } catch (err) { /* fall through and warn */ }

    var root = popup.el();
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    root.querySelector('[data-sp-prod-head]').textContent = 'This one can’t ship to ' + api.state.name;
    root.querySelector('[data-sp-prod-sub]').textContent = 'State law says this product can’t travel to ' + api.state.name + '. Plenty of others can, though.';
    popup.pendingHref = href;
    popup.open('product');
  }, true);

  /* ---- cart drawer banner: whole-cart eligibility. The drawer stamps
     line keys + tags on [data-dp-ship-cart]; every surgical re-render
     brings fresh JSON, and the MutationObserver below repaints it. ---- */
  function paintCartBanner() {
    var el = document.querySelector('[data-dp-ship-cart]');
    var known = false;
    if (el) {
      var s = api.state;
      var m = api.mode();
      if (!s || m === 'unknown') {
        el.hidden = true;
      } else {
        var lines = [];
        try { lines = JSON.parse(el.getAttribute('data-dp-lines') || '[]'); } catch (e) {}
        var bad = lines.filter(function (l) { return !api.productAllowed(l.tags); });
        var txt = el.querySelector('[data-dp-ship-cart-text]');
        var btn = el.querySelector('[data-dp-ship-cart-clear]');
        var place = s.code === 'INTL' ? 'the US' : s.name;
        if (!lines.length) {
          el.hidden = true;
        } else if (!bad.length) {
          txt.textContent = 'Your whole cart ships to ' + place;
          el.classList.remove('is-mixed');
          btn.hidden = true;
          el.hidden = false;
          known = true;
        } else {
          txt.textContent = bad.length === lines.length
            ? (s.code === 'INTL' ? 'We only ship within the US' : 'Nothing here can ship to ' + place)
            : 'Not everything here ships to ' + place;
          el.classList.add('is-mixed');
          btn.hidden = false;
          el.__dpBadKeys = bad.map(function (l) { return l.key; });
          el.hidden = false;
          known = true;
        }
      }
    }
    document.documentElement.classList.toggle('dp-ship-known', known);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dp-ship-cart-clear]');
    if (!btn) return;
    var el = btn.closest('[data-dp-ship-cart]');
    var keys = (el && el.__dpBadKeys) || [];
    if (!keys.length) return;
    btn.disabled = true;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    var SECTION_IDS = ['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock'];
    var release = function () { window.updatingCart = false; };
    window.updatingCart = true; // same mutex as the theme's own cart ops
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: SECTION_IDS.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        release();
        var helper = window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper');
        if (data && data.sections && helper && helper.reRenderSections) {
          Promise.resolve(helper.reRenderSections(data.sections)).then(function () {
            setTimeout(paintCartBanner, 150);
          });
        }
      })
      .catch(release);
  });

  /* The drawer has NO stable host to observe: it's AJAX-injected into a
     div inside the floating-header section at Alpine boot, and re-renders
     swap regions inside it. Repaint on the theme's own signals instead. */
  function watchDrawer() {
    var t = null;
    var queue = function (delay) {
      clearTimeout(t);
      t = setTimeout(paintCartBanner, delay);
    };
    // every cart mutation path (quick add, bundle, qty, remove) ends here
    document.addEventListener('eurus:cart:items-changed', function () { queue(350); });
    // drawer opening toggles html.dp-cart-open — by then the injected
    // markup (with fresh line JSON) is certainly in the DOM
    new MutationObserver(function () {
      if (document.documentElement.classList.contains('dp-cart-open')) queue(50);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    // initial injection happens shortly after Alpine boots — catch a
    // pre-filled cart without observing anything
    setTimeout(paintCartBanner, 1500);
    setTimeout(paintCartBanner, 4000);
  }

  document.addEventListener('dp:ship:ready', paintCartBanner);
  api.ready.then(function () { paintCartBanner(); watchDrawer(); });
})();
